import { Component, computed, signal, WritableSignal } from '@angular/core';
import {CommonModule} from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { DialogService } from 'src/app/core/services/dialog.service';
import { WaterSupplyZoneService } from '../../water-supply-zone.service';
import { FilesizePipe } from 'src/app/core/pipes/filesize.pipe';
@Component({
  selector: 'app-my-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    CommonModule,
    MyButtonComponent,
   MatFormFieldModule,
    MatSelectModule,
     MatInputModule,
     FormsModule,
     FilesizePipe
  ],
  templateUrl: './my-dialog.component.html',
  styleUrl: './my-dialog.component.css',
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

})
export class MyDialogComponent {
  selectedType: string = '';
  isEmpty: boolean = true;
  canSendGeoTextArea = computed(() => this.geoJsonTextArea() !== undefined);
  canSend = computed(() => this.selectedFile() !== undefined);
  canSendJson = computed(() => this.selectedFileJson() !== undefined);
  selectedFile: WritableSignal<any> = signal(undefined);
  selectedFileJson: WritableSignal<any> = signal(undefined);
  geoJsonTextArea: WritableSignal<any> = signal(undefined);
  isCheckingElaborazione = signal(false);
  dragging = signal(false);
  dati: any[] = [
    {value: 'shapeFile', viewValue: 'File ShapeFile'},
    {value: 'file-geoJson', viewValue: 'File GeoJson'},
    {value: 'geoJson', viewValue: 'GeoJson'},
  ];
  
  constructor(public dialogRef: MatDialogRef<MyDialogComponent>, 
       private dialogService: DialogService, 
      private readonly service: WaterSupplyZoneService,) {}

  onSendClickTextArea(){
    this.dialogRef.close({datiGeoRef:this.geoJsonTextArea(), selectedFile : this.selectedFile()});
  }

  onSendClick() {
    if (this.canSend() === true) {
 
          const reader = new FileReader();
          reader.readAsDataURL(this.selectedFile());
          reader.onload = async () => {
            const base64: any = reader.result?.toString().split(',')[1]
            const filePayload = {
              name: this.selectedFile().name,
              type: this.selectedFile().type,
              base64: base64,
            }
            this.service.sendFile(this.selectedFile()).subscribe((value) => {
              //this.dialogService.success('Il file è stato trasmesso ai server di AnTeA.', true);
              this.dialogRef.close({datiGeoRef:value, selectedFile : this.selectedFile()});
             
            
            })
          };
     
    }
  }

  onSendClickGeoJson() {
    if (this.canSendJson() === true) {
          const reader = new FileReader();
          reader.readAsDataURL(this.selectedFileJson());
          reader.onload = async () => {
            try {
              if (reader.result) {
                const base64String = (reader.result as string).split(',')[1]; // rimuove "data:application/json;base64,"
                const decodedString = atob(base64String);
                const json = JSON.parse(decodedString);
              
                console.log('JSON caricato:', json);
                this.dialogRef.close({ datiGeoRef: json, selectedFile: this.selectedFileJson() });
              }
              
  
            } catch (err) {
              console.error('Errore nel parsing del JSON:', err);
            }
          }
    };
       
  }

  checkContent(event: Event) {
    const textareaValue = (event.target as HTMLTextAreaElement).value;
    this.isEmpty = textareaValue.trim().length === 0;
    if(!this.isEmpty){
      this.geoJsonTextArea.set(textareaValue)
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(true);
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(false);
  }

  onDragOverJson(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(true);
  }

  onDragLeaveJson(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(false);
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(false);
    if (event.dataTransfer?.files.length) {
      this.onFileSelected({ target: { files: event.dataTransfer.files } });
    }
  }

  onFileDropJson(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(false);
    if (event.dataTransfer?.files.length) {
      this.onFileSelectedJson({ target: { files: event.dataTransfer.files } });
    }
  }

  resetForm() {
    this.selectedFile.set(undefined);
  }
  onFileSelected(event: any) {
    this.selectedFile.set(event.target.files[0] ?? null);
  }
  onFileSelectedJson(event: any) {
    this.selectedFileJson.set(event.target.files[0] ?? null);
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
